// Update cookie for Orbe Geolocation App
function setCountryForOrbe(value) {
  console.log("setCountryForOrbe to: "+value);
  document.cookie = 'mdApp_countryCodeDomain='+value+'; domain=vee-collective.com; path=/; max-age=${60 * 60 * 24 * 60};';
}
window.addEventListener('load', function () {
  if(typeof orbito !== "undefined") {
    const euCountry = ['DE','AT','BE','BG','CZ','DK','EE','IE','EL','ES','FR','HR','IT','CY','LV','LT','LU','HU','MT','NL','PL','PT','RO','SI','SK','FI','SE'];
    var orbeUsersCountry = '';
    setTimeout(function() {
    orbito.getRemoteCountryCode().then((value) => {
        orbeUsersCountry = value;
        if(euCountry.includes(orbeUsersCountry)) {  // is EU Country close popup
          orbito.closeModal('md-app-embed__modal');
        }
      });
    }, 1000);
    setTimeout(function() {
      document.body.classList.remove("block-orbe"); // allow orbe
    }, 3000);
  }
});


// Extra 15 Campaign
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}
function checkAndShowExtra15() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasParam = urlParams.get('sbar') === '1';
    const cookieValue = getCookie('veeShowBar');
    if (hasParam && cookieValue != 1) {
        const date = new Date();
        date.setTime(date.getTime() + (3 * 24 * 60 * 60 * 1000));
        document.cookie = `veeShowBar=1; expires=${date.toUTCString()}; path=/`;
		window.location.reload();
    }
    if (hasParam || cookieValue === '1' ) {
        console.log('show veeShowBar');

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            attributes: {
              veeShowBar: 1
             }
          })
        });

        document.body.classList.add('showAnnouncement');
		
		if( typeof document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== 'undefined' && document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== null ) {
			document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL').style.setProperty('display', 'block', 'important');
		}
		if( typeof document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== 'undefined' && document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== null ) {
			document.getElementById('shopify-section-template--25652475396362__homepage_blocks_7WVFmw').style.setProperty('display', 'block', 'important');
		}
		if( typeof document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== 'undefined' && document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== null ) {
			document.getElementById('shopify-section-template--25652475396362__homepage_blocks_DU7TrH').style.setProperty('display', 'none', 'important');
		}
		if( typeof document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== 'undefined' && document.getElementById('shopify-section-template--25652475396362__homepage_blocks_6eR9xL') !== null ) {
			document.getElementById('shopify-section-template--25652475396362__homepage_blocks_xbChCr').style.setProperty('display', 'none', 'important');
		}
    }
}
window.onload = checkAndShowExtra15;